export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp1 = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!?@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp1.test(password)
  return validPassword
}
